import { createContext, use, useCallback, useEffect, useRef, useState, type ReactNode } from 'react';
import { ownNotifications } from './windowLeadership';
import { useCompanion } from '../chat/companion/useCompanion';
const MODE_KEY = 'skrepka.workspace-window';
export function workspaceMode(search: string, saved: string | null) {
  return new URLSearchParams(search).get('workspace') === '1' || saved === '1';
}
export function regulationWindowUrl(projectId: number, regulationId: number) {
  return `/projects/${projectId}/assets/${regulationId}?workspace=1`;
}
type Session = { workspace: boolean; primary: boolean; isPrimary: () => boolean; companion?: ReturnType<typeof useCompanion> };
const Context = createContext<Session>({workspace:false,primary:true,isPrimary:()=>true});
export const useWindowSession = () => use(Context);
export function WindowSession({ userId, children }: { userId:number;children:ReactNode }) {
  const [workspace] = useState(() => {
    let saved=null;try {saved=sessionStorage.getItem(MODE_KEY);}catch { /* URL still works. */ }
    return workspaceMode(window.location.search,saved);
  });
  const [primary,setPrimary] = useState(false);
  const owner=useRef<ReturnType<typeof ownNotifications> | null>(null);
  const companion=useCompanion(userId,primary,workspace);
  const allowed=companion.isAllowed;
  const isPrimary=useCallback(()=>!workspace && Boolean(owner.current?.isPrimary()) && allowed(),[workspace,allowed]);
  useEffect(()=>{
    if (workspace) { try { sessionStorage.setItem(MODE_KEY,'1'); } catch { /* Keep this window's in-memory mode. */ } return; }
    owner.current=ownNotifications(userId,setPrimary);
    const restored=(event:PageTransitionEvent)=>{if(event.persisted){owner.current?.stop();owner.current=ownNotifications(userId,setPrimary);}};
    window.addEventListener('pageshow',restored);
    return ()=>{window.removeEventListener('pageshow',restored);owner.current?.stop();owner.current=null;};
  },[workspace,userId]);
  return <Context value={{workspace,primary:primary && companion.allowed,isPrimary,companion}}>{children}</Context>;
}
